import React, { useState } from "react";
import TextField from "@mui/material/TextField";

/**
 * CriteriaTextFieldComponent
 * Shared between PolicyTranslation and UseCases
 */
const CriteriaTextFieldComponent = ({
  totalCoverageCriteria,
  sx,
  disabled,
}) => {
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const regex = /^[0-9]{1,2}$/;

  const validateCoverageCriteria = (coverageCriteria) => {
    if (regex.test(coverageCriteria)) {
      setError(false);
      setHelperText("");
    } else {
      setError(true);
      setHelperText("Value must be from 1-99.");
    }
  };

  const handleChange = (event) => {
    validateCoverageCriteria(event.target.value.trim());
  };

  return (
    <TextField
      disabled={disabled}
      defaultValue={totalCoverageCriteria}
      error={error}
      helperText={helperText}
      onChange={handleChange}
      variant="outlined"
      size="small"
      inputProps={{ maxLength: "2" }}
      fullWidth
      sx={sx}
    />
  );
};

export default CriteriaTextFieldComponent;
